var render = function render(){var _vm=this,_c=_vm._self._c;return _c('okendo-star-rating',{staticClass:"c-star-rating",attrs:{"product-id":_vm.shopifyProductId},nativeOn:{"click":function($event){return _vm.handleClick.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }